import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';

import App from './App';
import reportWebVitals from './reportWebVitals';

import RecoilSyncLocalStorage from 'atoms/recoil-sync-ls';
import './index.css';
import 'cropperjs/dist/cropper.css'

import { UserProvider } from './context/user';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <RecoilRoot>
    <RecoilSyncLocalStorage storeKey="general">
      <UserProvider>
        <BrowserRouter basename="/app">
          <App />
        </BrowserRouter>
      </UserProvider>
    </RecoilSyncLocalStorage>
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
